import { useFetch } from '../query/reactQuery';

export const useGetAppointment = () =>
  useFetch<any>('https://jsonplaceholder.typicode.com/posts/1');
